import {
  CoverageStatusConfig,
  CoverageStatusLabels,
  InsuranceAccordionConfiguration,
  InsuranceStepConfiguration,
  InsuranceSteps,
} from '../types';
import SearchIcon from '@mui/icons-material/Search';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { LenderInsuranceRequirements } from '../ui/insuranceAccordion/LenderInsuranceRequirements';
import { AgentAndPolicyDetails } from '../ui/insuranceAccordion/agentAndPolicyDetails';
import { CertificateOfInsurance } from '../ui/insuranceAccordion/certificateOfInsurance';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';

export const stepperConfig: InsuranceStepConfiguration[] = [
  {
    label: InsuranceSteps.DetermineLenderRequirements,
    icon: SearchIcon,
    active: true,
    completed: false,
  },
  {
    label: InsuranceSteps.AgentInformationNeeded,
    icon: AssignmentIcon,
    active: false,
    completed: false,
  },
  {
    label: InsuranceSteps.VerifyCoverage,
    icon: CheckCircleOutlineIcon,
    active: false,
    completed: false,
  },
  {
    label: InsuranceSteps.ShareCOI,
    icon: ThumbUpAltIcon,
    active: false,
    completed: false,
  },
];

export const accordionConfig: InsuranceAccordionConfiguration[] = [
  {
    header: 'Lender Insurance Requirements',
    detailsComponent: LenderInsuranceRequirements,
    disabled: false,
    expanded: true,
  },
  {
    header: 'Agent & Policy Details',
    detailsComponent: AgentAndPolicyDetails,
    disabled: true,
    expanded: false,
  },
  {
    header: 'Certificate of Insurance',
    detailsComponent: CertificateOfInsurance,
    disabled: true,
    expanded: false,
  },
];

export const coverageStatusConfig: Record<CoverageStatusLabels, CoverageStatusConfig> = {
  [CoverageStatusLabels.Unknown]: {
    icon: FindInPageIcon,
    color: '#607D8B',
    bgColor: '#D9E0E3',
    label: CoverageStatusLabels.Unknown,
    helperText:
      'Coverage status hasn’t been confirmed yet. To verify coverage, please provide Agent & Policy Details — you can add them manually or request them from the applicant',
  },
  [CoverageStatusLabels.InsuredUnverified]: {
    icon: DoneIcon,
    color: '#FB8C00',
    bgColor: '#FFECD1',
    label: CoverageStatusLabels.InsuredUnverified,
    helperText:
      'Insurance details have been provided but not yet verified. You can still send an insurance quote or request verification from the agent',
  },
  [CoverageStatusLabels.InsuredVerified]: {
    icon: DoneAllIcon,
    color: '#689F38',
    bgColor: '#DCEDC8',
    label: CoverageStatusLabels.InsuredVerified,
  },
};
